import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form} from 'react-final-form';
import {Button} from "primereact/button";
import {addLocale} from "primereact/api";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";

const ReceiptImportFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
	const fileInputRef = useRef(null);
	const [selectedFile, setSelectedFile] = useState(null);
	const [fileUploading, setFileUploading] = useState(false);
  const [receiptGroups, setReceiptGroups] = useState([]);
  const [selectedReceiptGroup, setSelectedReceiptGroup] = useState(null);

  const validate = (data) => {
    let errors = {};
    if (!selectedReceiptGroup) {
      errors.receiptGroup = 'Kötelező mező';
    }
    if (!selectedFile) {
      errors.file = 'Kötelező mező';
    }
    return errors;
  };
  const onSubmit = (data, form) => {
    if (!selectedReceiptGroup) {
      window.App.toastShow('warn', props.t('attention'), props.t('selectReceiptGroupWarning'));
      return;
    }
    if (!selectedFile) {
      window.App.toastShow('warn', props.t('attention'), props.t('selectUploadFileWarning'));
      return;
    }
    setLoading(true);
    const uploadData = new FormData();
    uploadData.append('file', selectedFile);
    Object.keys(data || {}).forEach((key) => {
      if (data[key] !== undefined && data[key] !== null) {
        uploadData.append(key, data[key]);
      }
    });
    apiCall('post', '/api/v2/import-upload/szamlazz_hu?relatedEntityId=' + selectedReceiptGroup, uploadData)
      .then(response => {
        window.App.toastShow('success', 'Sikeres mentés!');
        window.App.setState({rerenderReceiptImportList: Math.random()});
        if (props.goback === true) {
          history.push(props.backlink);
        } else {
          history.push('/finance/receipt-import');
        }
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    apiCall('get', '/api/v2/receipt-group')
      .then((response) => {
        const items = response?.data?.data?.items || [];
        setReceiptGroups(items.filter(item => item.external === true));
      })
      .catch((error) => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        setReceiptGroups([]);
      });
  }, []);

  useEffect(() => {
    if ((!window.App.urlVars().create && window.App.urlVars().receiptImportId) || (entity === 'receipt-import' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/import-state/szamlazz_hu?relatedEntityId=' + (window.App.urlVars().receiptImportId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"receipt-import-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 "}>
              <div className={"p-lg-6"}>
							<div className="p-field p-fluid">
								<label htmlFor="file" className="p-d-block">{props.t('fieldFile')}</label>
								<span className="p-d-block">
										<input
											type="file"
											ref={fileInputRef}
											style={{ display: 'none' }}
											onChange={(e) => {
												const f = e.target.files?.[0] || null;
												setSelectedFile(f);
												e.target.value = null;
											}}
											disabled={loading || fileUploading}
										/>
										<Button
											type="button"
											className="p-button"
											style={{ width: 'auto', whiteSpace: 'nowrap' }}
											disabled={loading || fileUploading}
											onClick={() => fileInputRef.current?.click()}
										>
											<i className="pi pi-plus" />
											&nbsp;
											{fileUploading ? props.t('uploading') : (selectedFile?.name || props.t('chooseFile'))}
										</Button>
									</span>
							</div>
              </div>
              <div className={"p-lg-6"}>
                <div className="p-field p-fluid">
                  <label htmlFor="receiptGroup" className="p-d-block">{props.t('fieldReceiptGroup')}</label>
                  <Dropdown
                    id="receiptGroup"
                    value={selectedReceiptGroup}
                    options={window.App.sortDropdownOptions(receiptGroups, "name")}
                    optionLabel="name"
                    optionValue="id"
                    placeholder={t('selectReceiptGroupPlaceholder')}filter
                    showClear
                    appendTo={document.body}
                    disabled={loading || fileUploading}
                    onChange={(e) => {
                      setSelectedReceiptGroup(e.value);
                    }}
                  />
                </div>
              </div>
						</div>


          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'receipt-import' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(ReceiptImportFormComponent);
